import React from "react";
import { aboutMe } from "../data/mock";
import { CheckCircle } from "lucide-react";

const About = () => {
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        {/* Content */}
        <div className="space-y-8">
          <div>
            <h2 className="text-5xl lg:text-6xl font-light tracking-tight text-black mb-6">
              About Me
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed font-light">
              {aboutMe.description}
            </p>
          </div>

          {/* Highlights */}
          <div className="space-y-4">
            {aboutMe.highlights.map((highlight, index) => (
              <div 
                key={index}
                className="flex items-start space-x-3 group hover:translate-x-2 transition-transform duration-300"
              >
                <CheckCircle 
                  size={20} 
                  className="text-black mt-1 flex-shrink-0 group-hover:scale-110 transition-transform duration-300" 
                />
                <p className="text-gray-700 font-light leading-relaxed">
                  {highlight}
                </p>
              </div>
            ))}
          </div>

          {/* Mission Statement */}
          <div className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-xl font-light text-black mb-4 tracking-wide">
              Mission Statement
            </h3>
            <p className="text-gray-600 font-light leading-relaxed italic">
              {aboutMe.mission}
            </p>
            
            {/* Creator / Creator Echo Philosophy */}
            <div className="mt-6 pt-6 border-t border-gray-200">
              <div className="flex items-start space-x-3">
                <div className="w-1 h-full bg-gradient-to-b from-purple-500 via-orange-400 to-yellow-400 rounded-full flex-shrink-0" style={{minHeight: '60px'}}></div>
                <div>
                  <p className="text-xs uppercase tracking-widest text-purple-600 mb-2 font-medium">
                    Creator / Creator Echo
                  </p>
                  <p className="text-sm text-gray-700 font-light italic leading-relaxed">
                    "We bridge the trust for tomorrow. Divine Intelligence Illuminates, Human Intelligence Leads, AI Intelligence Expands©"
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Spiritual Artwork Visual Element */}
        <div className="relative">
          <div className="aspect-square bg-gradient-to-br from-purple-900/80 via-black/90 to-orange-900/80 rounded-lg relative overflow-hidden shadow-2xl border border-yellow-400/30">
            {/* A.R.T. ENERGI - Triad of Excellence Artwork */}
            <div className="absolute inset-0 flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_0fb4073d-6247-44e8-be18-a96e363bbb90/artifacts/3ymf8ihc_artenergi%20v2.png"
                alt="A.R.T. ENERGI - Authenticity Reliability Truth - Triad of Excellence"
                className="w-full h-full object-contain rounded-lg"
              />
            </div>
          </div>

          {/* Enhanced Philosophy Badge */}
          <div className="absolute -bottom-4 -right-4 bg-gradient-to-br from-black via-purple-900/80 to-orange-900/80 shadow-2xl rounded-lg p-6 border-2 border-yellow-400/50">
            <div className="text-center">
              <div className="text-xs uppercase tracking-widest text-yellow-400 mb-2 animate-pulse">
                Philosophy
              </div>
              <div className="text-sm font-light bg-gradient-to-r from-yellow-300 to-orange-400 bg-clip-text text-transparent tracking-wide">
                A.R.T. ENERGI
              </div>
              <div className="text-xs text-orange-200 mt-1">
                Authenticity | Reliability | Truth
              </div>
              <div className="text-xs text-purple-300 mt-2 italic">
                Triad of Excellence
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;